import React from "react";
import { Container, WrapperContainer } from "./TabsContainer.style";

export default class TabsContainer extends React.Component {
  render() {
    if (this.props.hidden) {
      return <React.Fragment />;
    }

    return <Container>
      <WrapperContainer>
        {this.props.children}
      </WrapperContainer>
  </Container>;
  }
}
